import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons'

import styles from './styles.module.scss'

const MapMarker = () => <FontAwesomeIcon className={styles.root} icon={faMapMarkerAlt} size="2x" color="#02A5CB" />

export default MapMarker
